const BillingPanel = () => import('@/components/billing/panel/BillingPanel.vue')

const permissionsBilling = [
  'panel_facturacion'
]

export const billingRoutes = [
  {
    path: '/billing',
    meta: { breadcrumb: 'Facturación', requiresAuth: true, permissions: permissionsBilling },
    children: [
      {
        path: 'panel',
        component: BillingPanel,
        meta: { breadcrumb: 'Panel de Administración', props: route => ({ query: route.query.option }), permissions: [permissionsBilling[0]] },
      },

    ],
  },
]
